import React from 'react';
import { UISref } from '@wix/tpa-router/react';

import { ChevronLeft as ChevronLeftIcon } from '@wix/wix-ui-icons-common/on-stage';

import { Box } from 'wui/Box';
import { Typography } from 'wui/Typography';
import { Button } from 'wui/Button';
import { ButtonGroup } from 'wui/ButtonGroup';

import { Link } from 'common/components/Link';
import { EventActions } from '../types';

type EventPageHeaderProps = {
  title: string;
  subtitle: string;
  actions: EventActions;
  isLoading?: boolean;
};

export function EventPageHeader({
  title,
  subtitle,
  actions,
  isLoading,
}: EventPageHeaderProps) {
  return (
    <Box align="space-between" data-hook="event-page-header">
      <Box direction="vertical" verticalAlign="middle">
        <Box gap="SP3">
          <Link
            wired
            variant="secondary"
            state="group.events.list"
            prefixIcon={<ChevronLeftIcon />}
          ></Link>
          <Typography as="h1" variant="h2-20">
            {title}
          </Typography>
        </Box>

        <Typography as="div" variant="p2-16">
          {subtitle}
        </Typography>
      </Box>

      <ButtonGroup orientation="horizontal">
        <UISref state="group.events.list">
          <Button
            as="a"
            outlined
            onClick={actions.secondary.onClick}
            data-hook="secondary-event-action"
          >
            {actions.secondary.label}
          </Button>
        </UISref>
        <Button
          type="submit"
          loading={isLoading}
          disabled={isLoading}
          onClick={actions.primary.onClick}
          data-hook="primary-event-action"
        >
          {actions.primary.label}
        </Button>
      </ButtonGroup>
    </Box>
  );
}

EventPageHeader.displayName = 'EventPageHeader';
